// Where the mobile app can be installed. Kept in one place because the dialog
// and the footer have to point at the same thing, and because a store link is
// the kind of value that changes without any code around it changing.
//
// IOS is an unlisted app: it never shows up in App Store search, so this exact
// link is the only way in. A user told to "look for it in the App Store" finds
// nothing.
export const AppStores = {
  IOS: 'https://apps.apple.com/app/community-coaching/id6782826236',
  ANDROID: 'https://play.google.com/store/apps/details?id=com.communitycoaching.app',
} as const;
